import React from 'react';
import { Modal } from 'reactstrap';
import { DynamicForm } from "./DynamicForm";

export const DynamicModal = ({config, toggleModal, ds, submitModes, banner=null}) => {

    return (
      <Modal size={config.size} isOpen={config.visible} toggle={()=>toggleModal({})} keyboard={false} backdrop="static" id="dynamic-modal">
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="myModalLabel">{!config.absoluteHeader && config.type && !config.customHeader ? config.type + " " : ""}{config.customHeader ? config.customHeader : config.header}</h5>
            <button type="button" onClick={() => toggleModal({})} className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          {config.visible && banner ? <div className="px-4 pt-3 print-hidden">{banner}</div> : null}
          <React.Fragment>
            {config.visible ? (
              <DynamicForm config={{...config, modal: true, toggleModal: toggleModal}} ds={ds} submitModes={submitModes} />
            ) : (
              <>
                <div id="modalBody" className="modal-body"></div>
                <div className="print-hidden modal-footer">
                  <button type="button" onClick={() => toggleModal({})} className="btn btn-secondary waves-effect" data-dismiss="modal">Close</button>
                </div>
              </>
            )}
              
          </React.Fragment>
      </Modal>
    )
}